var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileTypeAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 22,
    viewBox: "0 0 17 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5693 10.8324C12.5693 10.5824 12.3193 10.3324 12.0693 10.3324H5.06934C4.77767 10.3324 4.56934 10.5824 4.56934 10.8324V11.999C4.56934 12.2907 4.77767 12.499 5.06934 12.499H12.0693C12.3193 12.499 12.5693 12.2907 12.5693 11.999V10.8324ZM12.0693 13.8324H5.06934C4.77767 13.8324 4.56934 14.0824 4.56934 14.3324V15.499C4.56934 15.7907 4.77767 15.999 5.06934 15.999H12.0693C12.3193 15.999 12.5693 15.7907 12.5693 15.499V14.3324C12.5693 14.0824 12.3193 13.8324 12.0693 13.8324ZM16.5693 5.99902C16.5693 5.49902 16.3193 4.95736 15.9443 4.58236L12.486 1.12402C12.111 0.749023 11.5693 0.499023 11.0693 0.499023H2.56934C1.44434 0.499023 0.569336 1.41569 0.569336 2.49902V19.8324C0.569336 20.9574 1.44434 21.8324 2.56934 21.8324H14.5693C15.6527 21.8324 16.5693 20.9574 16.5693 19.8324V5.99902ZM11.236 2.66569L14.4027 5.83236H11.236V2.66569ZM14.5693 19.8324H2.56934V2.49902H9.236V6.83236C9.236 7.41569 9.65267 7.83236 10.236 7.83236H14.5693V19.8324Z",
    fill: "#49454F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileTypeAlt);
export default __webpack_public_path__ + "static/media/File_Type_Alt.720a1ab2842f7b780c1c20245a41aa99.svg";
export { ForwardRef as ReactComponent };